import { createClient } from 'contentful'

type GetEntryParams = {
  entryId: string;
  spaceId: string;
  accessToken: string;
  environment: string;
  preview: boolean;
}

function getContentfulApiBaseUrl (preview: boolean) {
  return preview ? 'preview.contentful.com' : 'cdn.contentful.com'
}

/**
 * Fetches a contentful entry
 * Examples:
 *
 * // Published content
 * const entry = await getContentfulEntry({
 *   entryId: 'your-entry-id',
 *   spaceId: 'your-space-id',
 *   accessToken: 'your-cda-token'
 * })
 *
 * // Draft content
 * const draftEntry = await getContentfulEntry({
 *   entryId: 'your-entry-id',
 *   spaceId: 'your-space-id',
 *   accessToken: 'your-preview-token',
 *   preview: true
 * })
 */
export async function getContentfulEntry (params: GetEntryParams) {
  const {
    entryId,
    spaceId,
    accessToken,
    environment,
    preview
  } = params

  const client = createClient({
    space: spaceId,
    accessToken,
    environment,
    host: getContentfulApiBaseUrl(preview)
  })

  try {
    const entry = await client.getEntry(entryId, { include: 3 })
    return entry
  } catch (error) {
    throw new Error(`Failed to fetch contentful entry ${entryId}: ${error}`)
  }
}
